import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dock"}/>
}
